import * as React from "react";
const SvgGreaterThan = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.5 17.5 8.25-5.5L6.5 6.5l1-1.5L18 12 7.5 19z",
  fillRule: "evenodd",
  fill: "currentColor"
}));
export default SvgGreaterThan;